import { useEffect } from "react";
import { useNewTrialState } from "../../new-trail/hooks/NewTrialStateProvider";
import {
  AUTOZONE_REQUEST_STATUS
} from "../types";
import { getCachedAutozonesData } from "./autozoneServices";

const UseAutozoneNetworkCalls = (visible: boolean, fieldId: string): any => {
  const {
    autozoneRequestStatus,
    setAutozoneRequestStatus,
    autozonesData,
    setAutozonesData,
  } = useNewTrialState();

  const getAutozonesData = async (): Promise<any> => {
    try {
      setAutozoneRequestStatus(AUTOZONE_REQUEST_STATUS.LOADING);
      const autozoneCachedData = await getCachedAutozonesData(fieldId);
      if (!autozoneCachedData) throw new Error("No Autozones Data");
      setAutozonesData(autozoneCachedData);
      setAutozoneRequestStatus(AUTOZONE_REQUEST_STATUS.SUCCESS);
    } catch (error) {
      console.error("Error in Autozones data fetching flow:", error);
      setAutozoneRequestStatus(AUTOZONE_REQUEST_STATUS.ERROR);
    }
  };

  useEffect(() => {
    if (
      (visible &&
        fieldId &&
        autozoneRequestStatus === AUTOZONE_REQUEST_STATUS.DEFAULT) ||
      (fieldId && autozoneRequestStatus === AUTOZONE_REQUEST_STATUS.RETRY)
    ) {
      getAutozonesData().catch((error) => {
        console.error(" error in getAutozonesData:", error);
        setAutozoneRequestStatus(AUTOZONE_REQUEST_STATUS.ERROR);
      });
    }
  }, [fieldId, visible, autozoneRequestStatus]);

  return { autozonesData };
};

export default UseAutozoneNetworkCalls;
